const buildAdminMicroAppsPath = (): string => '/admin/micro-apps';

export default buildAdminMicroAppsPath;
